































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import DeliveryReceiverResponse from '@/model/response/DeliveryReceiverResponse'
import DeliveryReceiverRequest from '@/model/request/DeliveryReceiverRequest'
import FilterDeliveryReceiver from '@/components/filters/FilterDeliveryReceiver.vue'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryReceiver.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliveryReceiver},
})
export default class ReportsDeliveryReceiverView extends Mixins(MixinFilter) {
  filter = new DeliveryReceiverRequest()
  collection = new PageCollection(DeliveryReceiverResponse, this.filter, 10)

  AppConfig = AppConfig

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
        const csv = new PageCollection(DeliveryReceiverResponse, this.filter, null, null)

        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv(snakeCase($.t('view.reports.deliveryReceiver.title')))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.deliveryReceiver.title'),
          new DeliveryReceiverResponse().$endpoint,
          this.filter,
          DeliveryReceiverResponse,
          'DeliveryReceiverResponse',
          ), 'download')
    }
  }
}
